// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2hRTa","calendarButtons":"ClockData_calendarButtons__3afzB"};